<template>
  <!-- grid of registered paying users, with filters, stock buttons (CRUD), pagination and possibility to enable and disable the user. -->

  <div>
    <preload v-if="preload"></preload>
    <nav-bar></nav-bar>
    <div style="min-height: 100vh">
      <div class="container contact">
        <div class="row" style="padding-top: 30px">
          <!-- DESKTOP SCREEN -->

          <div class="col-md-12 class-desktop">
            <p class="page-user">Usuário pagador</p>

            <div class="form-group">
              <div class="row" style="width: 100%">
                <div class="col-md-12">
                  <div style="margin-top: -30px; margin-left: -23px">
                    <div>
                      <button
                        id="filterRegisteredPayer"
                        style="background-color: transparent"
                        data-target="#filterinputsdesktop"
                        data-toggle="collapse"
                        class="btn colaccordion-toggle"
                      >
                        Filtro
                        <em class="fa fa-chevron-down icons icon-chevron"></em>
                      </button>
                    </div>

                    <div class="hiddenRow column">
                      <div
                        class="accordian-body collapse"
                        style="margin-left: 10px"
                        id="filterinputsdesktop"
                      >
                        <div class="form-group">
                          <form
                            @submit.prevent="setFilter(filterSearch, filterText, true)"
                            class="has-search"
                          >
                            <div style="display: flex">
                              <select
                                v-model="filterSearch"
                                class="selectpicker"
                                v-on:change="clearFilterText"
                              >
                                <option value="selecione">Selecione</option>
                                <option value="name">Nome</option>
                                <option value="login">Login</option>
                                <!-- <option value="registration">Inscrição</option> -->
                              </select>

                              <input
                                id="filterSearchRegisteredPayer"
                                type="text"
                                class="form-control"
                                placeholder="Digite o que deseja filtrar"
                                v-model="filterText"
                                :disabled="filterSearch == 'selecione'"
                                style="width: 35%"
                                min="3"
                              />
                            </div>
                            <div
                              style="display: flex; justify-content: flex-end"
                            >
                              <button
                                id="buttonSearchRegisteredPayer"
                                class="btn btn-lg access-filter"
                                type="submit"
                              >
                                Pesquisar
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="">
              <div class="btn-group-status">
                <div
                  class="btn-group"
                  style="margin-bottom: 10px; width: 50%"
                  role="group"
                  aria-label="Basic example"
                >
                  <button
                    id="statusRegisteredPayerOne"
                    type="button"
                    class="btn btn-filter"
                    v-on:click="setFilter('status', 'H')"
                    v-bind:class="{ 'btn-checked': filters.status == 'H' }"
                  >
                    Habilitados
                  </button>
                  <button
                    id="statusRegisteredPayerTwo"
                    type="button"
                    class="btn btn-filter"
                    v-on:click="setFilter('status', 'D')"
                    v-bind:class="{ 'btn-checked': filters.status == 'D' }"
                  >
                    Desabilitados
                  </button>
                  <button
                    id="statusRegisteredPayerThree"
                    type="button"
                    class="btn btn-filter"
                    v-on:click="removeFilter('status')"
                    v-bind:class="{
                      'btn-checked': filters.status == undefined,
                    }"
                  >
                    Todos
                  </button>
                </div>
              </div>
              <!-- table of registered users desktop screen -->
              <div class="table-wrapper-scroll-y my-custom-scrollbar">
                <table class="table">
                  <thead style="line-height: 5px">
                    <tr
                      style="
                        background-color: #ebe7e7 !important;
                        font-size: 14px;
                        text-align: center;
                      "
                    >
                      <th></th>
                      <th style="padding-bottom: 15px">Status</th>
                      <th style="padding-bottom: 15px">Ações</th>
                      <th @click="sort('usu_nome')">
                        Nome<em
                          class="fa fa-sort-down"
                          v-if="filters.order_by == 'usu_nome;asc'"
                        ></em
                        ><em
                          class="fa fa-sort-up"
                          v-if="filters.order_by == 'usu_nome;desc'"
                        ></em>
                      </th>
                      <th @click="sort('usu_login')">
                        Login<em
                          class="fa fa-sort-down"
                          v-if="filters.order_by == 'usu_login;asc'"
                        ></em
                        ><em
                          class="fa fa-sort-up"
                          v-if="filters.order_by == 'usu_login;desc'"
                        ></em>
                      </th>
                      <th @click="sort('per_descricao')">
                        Perfil<em
                          class="fa fa-sort-down"
                          v-if="filters.order_by == 'per_descricao;asc'"
                        ></em
                        ><em
                          class="fa fa-sort-up"
                          v-if="filters.order_by == 'per_descricao;desc'"
                        ></em>
                      </th>
                      <th @click="sort('usu_email')">
                        E-mail<em
                          class="fa fa-sort-down"
                          v-if="filters.order_by == 'usu_email;asc'"
                        ></em
                        ><em
                          class="fa fa-sort-up"
                          v-if="filters.order_by == 'usu_email;desc'"
                        ></em>
                      </th>

                      <th @click="sort('usu_qtd_acesso')">
                        Acesso<em
                          class="fa fa-sort-down"
                          v-if="filters.order_by == 'usu_qtd_acesso;asc'"
                        ></em
                        ><em
                          class="fa fa-sort-up"
                          v-if="filters.order_by == 'usu_qtd_acesso;desc'"
                        ></em>
                      </th>
                      <th @click="sort('usu_dt_ultimo_acesso')">
                        Último acesso<em
                          class="fa fa-sort-down"
                          v-if="filters.order_by == 'usu_dt_ultimo_acesso;asc'"
                        ></em
                        ><em
                          class="fa fa-sort-up"
                          v-if="filters.order_by == 'usu_dt_ultimo_acesso;desc'"
                        ></em>
                      </th>
                      <th></th>
                      <!-- <th @click="sort('usu_inscricao')">
                        Inscrição<em class="fa fa-sort-down"></em>
                      </th> -->
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="payer in payers" :key="'grid_' + payer.usu_id">
                      <th scope="row"></th>
                      <td class="align-middle" style="padding-left: 0px">
                        <label class="switch">
                          <input
                            id="statusSliderRegisteredPayer"
                            v-on:click="changeStatus(payer.usu_id, $event)"
                            type="checkbox"
                            :checked="payer.usu_status === 'H'"
                            class="success"
                          />
                          <span class="slider"></span>
                        </label>
                      </td>
                      <td class="align-middle">
                        <div class="dropdown">
                          <button
                            id="dropdownRegisteredPayer"
                            type="submit"
                            class="icons-btn"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            <em class="fa fa-ellipsis-h icons"></em>
                          </button>

                          <div class="dropdown-menu items-style">
                            <button
                              id="openReadModal"
                              class="btn btn-lg dropdown-item font-style"
                              type="submit"
                              data-target="#readUserModal"
                              data-toggle="modal"
                              @click="openReadModal(payer.usu_id)"
                            >
                              <em class="fa fa-search-plus fa-icon"></em>
                              Visualizar
                            </button>

                            <button
                              id="openEditModal"
                              class="btn btn-lg dropdown-item font-style"
                              type="submit"
                              data-target="#editUserModal"
                              data-toggle="modal"
                              @click="openEditModal(payer.usu_id)"
                            >
                              <em class="fa fa-edit fa-icon"></em>
                              Editar
                            </button>

                            <button
                              id="openResetModal"
                              class="btn btn-lg dropdown-item font-style"
                              data-target="#resetPasswordModal"
                              data-toggle="modal"
                              type="submit"
                              @click="openResetModal(payer.usu_id)"
                            >
                              <em class="fa fa-key fa-user-style-menu fa-icon">
                              </em>
                              Resetar senha
                            </button>
                          </div>
                        </div>
                      </td>
                      <td class="align-middle">
                        {{ payer.usu_nome }}
                      </td>
                      <td class="align-middle">{{ payer.usu_login }}</td>

                      <td class="align-middle">{{ payer.per_descricao }}</td>
                      <td class="align-middle">{{ payer.usu_email }}</td>

                      <td class="align-middle">{{ payer.usu_qtd_acesso }}</td>
                      <td class="align-middle">
                        {{ payer.usu_dt_ultimo_acesso | formatDateTime }}
                      </td>
                      <!-- <td class="align-middle">
                        {{ payer.usu_inscricao | formatCPFCNPJ }}
                      </td> -->
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="buttons-flutter-desktop">
                <!-- pagination of registered users desktop screen -->
                <div>
                  <button
                    id="openCreateUserModal"
                    class="btn btn-lg access"
                    style="margin-right: 5px"
                    type="submit"
                    data-toggle="modal"
                    data-target="#userModal"
                    @click="updateComponent"
                  >
                    Criar Usuário
                  </button>
                </div>
                <pagination
                  v-if="pagination.last_page > 1"
                  :pagination="pagination"
                  :offset="5"
                  @paginate="getPayers()"
                ></pagination>

                <p class="total-page">
                  Total de pagadores:
                  <span style="margin-left: 2px">
                    {{ this.pagination.total }}</span
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- END OF DESKTOP SCREEN -->

        <!-- MOBILE SCREEN -->
        <!-- form filters of registered users mobile screen -->
        <div class="row justify-content-center class-mobile">
          <div class="col-md-8"></div>
          <div class="col-md-8">
            <p class="page-user">Usuário pagador</p>
            <div style="margin-bottom: 15px; margin-left: -23px">
              <div style="margin-left: 10px">
                <button
                  id="collapseFilterPayers"
                  style="background-color: transparent"
                  data-toggle="collapse"
                  data-target="#filterinputs"
                  class="btn colaccordion-toggle"
                >
                  Filtro <em class="fa fa-chevron-down icons icon-chevron"></em>
                </button>
              </div>

              <div class="hiddenRow column">
                <div
                  class="accordian-body collapse"
                  style="margin-left: 30px"
                  id="filterinputs"
                >
                  <div class="form-group">
                    <form
                      @submit.prevent="
                        setFilter(filterSearch, filterText, true)
                      "
                      class="has-search"
                    >
                      <div style="display: flex">
                        <select
                          v-model="filterSearch"
                          class="selectpicker"
                          v-on:change="clearFilterText"
                        >
                          <option value="selecione">Selecione</option>
                          <option value="name">Nome</option>
                          <option value="login">Login</option>
                          <!-- <option value="registration">Inscrição</option> -->
                        </select>
                        <input
                          id="searchFilterPayers"
                          type="text"
                          class="form-control"
                          placeholder="Digite o que deseja filtrar"
                          v-model="filterText"
                          :disabled="filterSearch == 'selecione'"
                          style="width: 60%; font-size: 13px; margin-left: 10px"
                          min="3"
                        />
                      </div>
                      <div style="display: flex; justify-content: center">
                        <button
                          id="buttonSearchFilterPayers"
                          class="btn btn-lg access"
                          type="submit"
                          style="width: 30%"
                        >
                          Pesquisar
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="btn-group"
              style="justify-content: center; display: flex"
              role="group"
              aria-label="Basic example"
            >
              <button
                id="buttonFilterPayersOne"
                type="button"
                class="btn btn-filter"
                v-on:click="setFilter('status', 'H')"
                v-bind:class="{ 'btn-checked': filters.status == 'H' }"
              >
                Habilitados
              </button>
              <button
                id="buttonFilterPayersTwo"
                type="button"
                class="btn btn-filter"
                v-on:click="setFilter('status', 'D')"
                v-bind:class="{ 'btn-checked': filters.status == 'D' }"
              >
                Desabilitados
              </button>
              <button
                id="buttonFilterPayersThree"
                type="button"
                class="btn btn-filter"
                v-on:click="removeFilter('status')"
                v-bind:class="{ 'btn-checked': filters.status == undefined }"
              >
                Todos
              </button>
            </div>
            <!-- table list of registered users mobile screen -->
            <div
              v-for="payer in payers"
              :key="'grid_' + payer.usu_id"
              class="principal-div"
            >
              <div class="col col-divs">
                <div style="width: 45%">
                  <label>Login</label><br />
                  {{ payer.usu_login }}
                </div>
                <div style="width: 45%">
                  <label>Último acesso</label><br />
                  {{ payer.usu_dt_ultimo_acesso | formatDateTime }}
                </div>

                <button
                  id="collapseRegisteredPayerMobile"
                  style="width: 15%; background-color: #fff"
                  class="btn accordion-toggle"
                  data-toggle="collapse"
                  :data-target="'#' + payer.usu_id"
                >
                  <em class="fa fa-chevron-down icons icon-chevron"></em>
                </button>
              </div>

              <div class="hiddenRow column">
                <div class="accordian-body collapse" :id="payer.usu_id">
                  <div class="col col-divs">
                    <div style="width: 90%">
                      <label>Nome</label><br />
                      {{ payer.usu_nome }}
                    </div>

                    <button
                      id="openReadModalMobile"
                      style="width: 15%; background-color: #fff"
                      class="btn"
                      data-toggle="modal"
                      data-target="#readUserModal"
                      @click="openReadModal(payer.usu_id)"
                    >
                      <em class="fa fa-search-plus icons"></em>
                    </button>
                  </div>
                  <div class="col col-divs">
                    <div style="width: 100%">
                      <label>E-mail</label><br />{{ payer.usu_email }}
                    </div>

                    <button
                      id="openEditModalMobile"
                      style="width: 15%; background-color: #fff"
                      class="btn"
                      data-toggle="modal"
                      data-target="#editUserModal"
                      @click="openEditModal(payer.usu_id)"
                    >
                      <em class="fa fa-edit icons"></em>
                    </button>
                  </div>
                  <div class="col col-divs">
                    <div style="width: 30%">
                      <label>Perfil</label><br />{{ payer.per_descricao }}
                    </div>

                    <div style="width: 30%">
                      <label>Acessos</label><br />{{ payer.usu_qtd_acesso }}
                    </div>
                    <div style="width: 30%">
                      <label>Status</label><br />
                      <label class="switch">
                        <input
                          id="sliderChackboxMobile"
                          v-on:click="changeStatus(payer.usu_id, $event)"
                          type="checkbox"
                          :checked="payer.usu_status === 'H'"
                          class="success"
                        />
                        <span class="slider"></span>
                      </label>
                    </div>
                    <!-- <div class="col col-divs">
                    <div style="width: 100%">
                      <label>Inscrição</label><br />
                      {{ payer.usu_inscricao }}
                    </div>
                  </div> -->

                    <button
                      id="openResetModalMobile"
                      style="width: 15%; background-color: #fff"
                      class="btn"
                      data-toggle="modal"
                      data-target="#resetPasswordModal"
                      @click="openResetModal(payer.usu_id)"
                    >
                      <em class="fa fa-key icons"></em>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="buttons-flutter">
              <div>
                <button
                  id="openCreateModalMobile"
                  class="btn btn-lg access-mobile"
                  style="margin-right: 5px"
                  type="submit"
                  data-toggle="modal"
                  data-target="#userModal"
                  @click="updateComponent"
                >
                  Criar Usuário
                </button>
              </div>
              <p class="total-page">
                Total de pagadores: {{ this.pagination.total }}
              </p>
            </div>
            <!-- pagination of registered users mobile screen -->

            <pagination
              v-if="pagination.last_page > 1"
              :pagination="pagination"
              :offset="5"
              @paginate="getPayers()"
            ></pagination>
            <!-- END OF MOBILE SCREEN -->
          </div>
        </div>
      </div>
      <modal-user v-if="show" @updateTable="getPayers"></modal-user>
      <edit-modal-user
        v-if="showEditModal"
        :key="renderEditModal"
        v-bind="showEditModalProps"
        @updateTable="getPayers"
      ></edit-modal-user>
      <read-modal-user
        v-if="showReadModal"
        :key="renderReadModal"
        v-bind="showReadModalProps"
      ></read-modal-user>
      <reset-password-modal
        v-if="showResetModal"
        :key="renderResetModal"
        v-bind="showResetModalProps"
      ></reset-password-modal>
    </div>
    <footer-nav></footer-nav>
  </div>
</template>
<script>
import Vue from "vue";
import NavBar from "../../../common/components/NavBar";
import axios from "axios";
import Pagination from "../../../common/components/Pagination";
import * as cpf from "@fnando/cpf";
import ModalUser from "./create/ModalUser";
import EditModalUser from "./edit/EditModalUser";
import ReadModalUser from "./read/ReadModalUser";
import ResetPasswordModal from "./reset/ResetPasswordModal";
import FooterNav from "../../../common/components/FooterNav";
import Preload from "../../../common/components/Preload";
import preload from "../../../common/components/Preload.vue";

export default {
  components: {
    Preload,
    Pagination,
    NavBar,
    ModalUser,
    EditModalUser,
    ReadModalUser,
    FooterNav,
    ResetPasswordModal,
    buttonChecked: "H",
  },
  name: "RegisteredPayerUser",

  data() {
    return {
      payers: [],
      pagination: {
        current_page: 1,
      },
      filters: {
        status: "H",
        order_by: "usu_dt_ultimo_acesso;desc",
      },
      currentSort: "",
      currentSortDir: "asc",
      filterText: "",
      preload:false,
      show: true,
      showEditModal: false,
      showReadModal: false,
      showResetModal: false,
      userId: false,
      renderEditModal: Math.random(),
      renderReadModal: Math.random(),
      renderResetModal: Math.random(),

      filterSearch: "",
    };
  },

  methods: {
    changeStatus: function (id, event) {
      let data = {
        user_status: "D",
        user_id: id,
      };
      if (event.target.checked) {
        data.user_status = "H";
      }
      axios
        .put(`${process.env.API_PBM}/user/setStatus`, this.$qs.stringify(data))
        .then((response) => {});
    },
    getPayers: function (firstPage = false) {
      this.preload = true;
      if (firstPage) {
        this.pagination = {
          current_page: 1,
        };
      }
      axios
        .get(
          `${process.env.API_PBM}/payers?page=${this.pagination.current_page}`,
          {
            params: this.filters,
          }
        )
        .then((response) => {
          this.payers = response.data.data.payers;
          if (this.payers) {
            this.pagination = response.data.data.pagination;
            this.preload = false;
            return;
          }

          this.pagination.total = 0;
          this.preload = false;
        }).catch(error => {
        this.preload = false;
      });
    },
    setFilter: function (filter, value, reset = false) {
      if (reset) {
        this.filters = {};
      }
      this.filters[filter] = value;
      this.getPayers(true);
      this.buttonChecked = value;
    },

    removeFilter: function (filter) {
      delete this.filters[filter];
      this.getPayers(true);
      this.buttonChecked = "todos";
    },

    clearFilterText: function () {
      this.filterText = "";
      if (this.filterSearch === "selecione") {
        this.filters = {};
        this.getPayers(true);
      }
    },

    sort: function (field) {
      if (field === this.currentSort) {
        this.currentSortDir = this.currentSortDir === "asc" ? "desc" : "asc";
      }
      this.currentSort = field;
      this.filters["order_by"] = `${field};${this.currentSortDir}`;
      this.getPayers();
    },

    searchPayers: function () {},

    updateComponent: function (usu_id) {
      var self = this;
      self.show = false;
      Vue.nextTick(function () {
        self.show = true;
      });
    },

    openEditModal: function (usu_id) {
      this.showEditModal = true;
      this.userId = usu_id;
      this.renderEditModal += 1;
    },
    openReadModal: function (usu_id) {
      this.showReadModal = true;
      this.userId = usu_id;
      this.renderReadModal += 1;
    },
    openResetModal: function (usu_id) {
      this.showResetModal = true;
      this.userId = usu_id;
      this.renderResetModal += 1;
    },
  },
  mounted() {
    this.$store.state.navBarActive = "";
    this.getPayers();

    this.filterSearch = "selecione";
  },
  computed: {
    showEditModalProps: function () {
      return { userId: this.userId };
    },
    showReadModalProps: function () {
      return { userId: this.userId };
    },
    showResetModalProps: function () {
      return { userId: this.userId };
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.page-user {
  font-size: 18px;
  margin-bottom: 15px;
  display: block;
  margin-top: -5px;
}

.dropdown {
  position: inherit;
}

.btn-group-status {
  display: flex;
  justify-content: space-between;
  margin-top: -20px;
}
.btn-checked {
  color: #fff;
  background-color: #9c9a9a;
  border: 1px solid #ebe7e7;
}
table thead {
  background-color: #cacaca;
  color: rgb(100, 95, 95);
  z-index: 2;
  position: inherit;
}

.table {
  position: relative;
}
.my-custom-scrollbar {
  position: relative;
  height: 350px;
  overflow: auto;
}
.table-wrapper-scroll-y {
  display: block;
}

.table thead th {
  position: sticky;
  top: 0;
  background-color: rgb(235, 231, 231) !important;
}
table tr {
  white-space: nowrap;
}
tbody {
  font-size: 12px;
  color: rgb(100, 95, 95);
}

.total-page {
  color: rgb(100, 95, 95);
  font-size: 14px;
}
.has-search .form-control-feedback {
  color: gray;
  margin-top: 4px;
  margin-left: 10px;
  width: 100%;
}

.fa-sort-down {
  margin-left: 5px;
  cursor: pointer;
  color: #424242;
}
.fa-sort-up {
  margin-left: 5px;
  cursor: pointer;
  position: absolute;
  color: #424242;
}
.icons {
  font-size: 20px;
  cursor: pointer;
}

.icons-btn {
  background-color: #fff;
  cursor: pointer;
  border: none;
}

.font-style {
  font-size: 13px;
  color: rgb(100, 95, 95);
  cursor: pointer;
  padding: 10px;
}

.fa-icon {
  color: #424242;
}

.fa-style {
  font-size: 17px;
  padding-left: 30px;
  color: rgb(100, 95, 95);
}

.items-style {
  box-shadow: rgb(100, 95, 95) !important;
}

.btn {
  line-height: 1rem;
}

.btn-filter {
  color: #424242;
  background-color: #fff;
  border: 1px solid #ebe7e7;
  width: 120px;
}
.btn-filter:hover {
  color: #fff !important;
  background-color: #9c9a9a;
  border: 1px solid #ebe7e7;
}
.btn-checked {
  color: #fff;
  background-color: #9c9a9a;
  border: 1px solid #ebe7e7;
}

.contact {
  padding: 4%;
}

.contact-info h2 {
  margin-bottom: 10%;
}
.col-md-12 {
  background: #fff;
  padding: 3%;
  border-radius: 0.2rem;
}
.contact-form label {
  font-weight: 600;
}

label {
  font-size: 17px;
  color: rgb(100, 95, 95);
  margin-bottom: 1px;
}
.form-group input,
textarea {
  background-color: #fff;
  margin-bottom: 10px;
  margin-top: 3px;
  line-height: 1rem;
  font-size: 15px;
  margin-left: 10px;
  width: 42%;
}
.form-control:disabled {
  background-color: #e9ecef;
  opacity: 1;
}
.btn:focus {
  box-shadow: none !important;
}

.access {
  color: #fff;
  border-radius: 6px;
  cursor: pointer;
  padding: 5px;
  font-size: 12px;
}

.access-filter {
  color: #fff;
  border-radius: 6px;
  cursor: pointer;
  padding: 5px;
  font-size: 15px;
  height: 32px;
  width: 15%;
  margin-top: -42px;
}

.selectpicker {
  height: 30px;
  font-size: 13px;
  color: rgb(100, 95, 95);
  width: 15%;
  margin-top: 5px;
}

.buttons-flutter-desktop {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
}
.contact-form button:focus {
  box-shadow: none;
}

/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 49px;
  height: 26px;
  float: left;
}

/* Hide default HTML checkbox */
.switch input {
  display: none;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 13px;
  left: 16px;
  right: 9px;
  bottom: 2px;
  border-radius: 12px;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 12px;
  width: 13px;
  left: -8px;
  bottom: -1px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 17px;
  box-shadow: 1px 1px 1px;
}

input.success:checked + .slider {
  background-color: #58970f;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

@media only screen and (max-width: 900px) {
  .page-user {
    font-size: 20px;
    display: flex;
    justify-content: center;
  }

  .class-mobile {
    display: flex !important;
    width: 100%;
    margin: 0 auto;
  }
  .class-desktop {
    display: none !important;
  }

  .col-md-8 {
    background: #ebe7e7;
    padding: 3%;
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }

  .buttons-footer {
    display: flex;
    justify-content: space-between;
    margin-top: 25px;
  }

  .access {
    color: #fff;
    border-radius: 6px;
    width: 45%;
    height: 70%;
    font-size: 11px;
    cursor: pointer;
    padding: 5px;
    font-size: 12px;
    text-align: center;
  }

  .btn-filter {
    color: #424242;
    background-color: #fff;
    border: 1px solid #ebe7e7;
    font-size: 14px;
    line-height: 1;
    width: 35%;
    cursor: pointer;
  }
  .btn-filter:hover {
    color: #fff !important;
    background-color: #9c9a9a;
    border: 1px solid #ebe7e7;
  }
  .btn-checked {
    color: #fff;
    background-color: #9c9a9a;
    border: 1px solid #ebe7e7;
  }

  .hiddenRow {
    padding: 0 !important;
  }

  label {
    display: inline-block;
    font-size: 13px;
    color: #424242;
  }

  .icons {
    font-size: 20px;
    cursor: pointer;
  }

  .col-divs {
    display: inline-flex;
    margin: 0 auto;
    font-size: 11px;
  }

  .principal-div {
    margin-top: 20px;
    background-color: #fff;
    border-radius: 6px;
    padding: 5px;
    color: rgb(100, 95, 95);
  }
  .access-filter {
    color: #fff;
    border-radius: 6px;
    cursor: pointer;
    padding: 5px;
    font-size: 15px;
    height: 33px;
    width: 20%;
  }
  .access-mobile {
    color: #fff;
    border-radius: 6px;
    width: 100%;
    height: 70%;
    font-size: 11px;
    cursor: pointer;
    padding: 5px;
    font-size: 12px;
    text-align: center;
  }

  .form-group input,
  textarea {
    background-color: #fff;
    margin-bottom: 10px;
    margin-top: 3px;
    line-height: 1rem;
    font-size: 15px;
    margin-left: 0px;
    width: 100%;
  }

  .switch {
    position: relative;
    display: inline-block;
    width: 49px;
    height: 26px;
    float: left;
  }

  /* Hide default HTML checkbox */
  .switch input {
    display: none;
  }

  /* The slider */
  .slider {
    position: absolute;
    cursor: pointer;
    top: 6px;
    left: 16px;
    right: 9px;
    bottom: 10px;
    border-radius: 12px;
    background-color: #ccc;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 12px;
    width: 13px;
    left: -8px;
    bottom: -1px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 17px;
    box-shadow: 1px 1px 1px;
  }

  input.success:checked + .slider {
    background-color: #58970f;
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }

  .selectpicker {
    width: 35%;
  }
}

.class-mobile {
  display: none;
}

.buttons-flutter {
  display: flex;
  justify-content: space-between;
  margin-top: 25px;
}

.access {
  color: #fff;
  border-radius: 6px;
  width: 100%;
  height: 70%;
  font-size: 11px;
  cursor: pointer;
  padding: 5px;
  font-size: 12px;
  text-align: center;
}

.btn-filter {
  color: #424242;
  background-color: #fff;
  border: 1px solid #ebe7e7;
  font-size: 14px;
  line-height: 1;
  width: 35%;
  cursor: pointer;
}
.btn-filter:hover {
  color: #fff !important;
  background-color: #9c9a9a;
  border: 1px solid #ebe7e7;
}
.btn-checked {
  color: #fff;
  background-color: #9c9a9a;
  border: 1px solid #ebe7e7;
}
.dropdown-menu {
  box-shadow: 0px 0px 7px gray !important;
  padding: 6px;
}
</style>



// WEBPACK FOOTER //
// src/views/components/user/RegisteredPayerUser.vue